export default "/_next/static/images/a0d186b37ca1c5d6c329a0cf88f5064e.jpg";